import { useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { Megaphone, Building2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { homeFor } from "@/lib/constants";
import { CheckEmail } from "@/components/auth/CheckEmail";
import { RegisterPersonForm } from "@/components/auth/RegisterPersonForm";
import { RegisterCompanyForm } from "@/components/auth/RegisterCompanyForm";

const TABS = [
  { to: "/registrati", label: "Segnalo", icon: Megaphone, id: "person" },
  { to: "/registrati/azienda", label: "Sono un'azienda", icon: Building2, id: "company" },
];

export default function Register() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [sentTo, setSentTo] = useState("");
  const company = pathname.endsWith("/azienda");

  if (user) return <Navigate to={homeFor(user)} replace />;

  return (
    <main className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:py-14" data-testid="register-page">
      <div className="rise rounded-3xl border border-[#E2E5DC] bg-white p-6 shadow-[0_20px_60px_-30px_rgba(15,45,94,0.35)] sm:p-10">
        {sentTo ? <CheckEmail email={sentTo} /> : (
          <>
            <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl">Crea il tuo account</h1>
            <p className="mt-2 text-sm text-[#495850]">
              {company ? "Ricevi clienti dal passaparola: registra la tua azienda e scegli il piano." : "Segnala chi cerca un servizio e incassa quando la segnalazione va a buon fine."}
            </p>
            <div className="mt-6 grid grid-cols-2 gap-2 rounded-full bg-[#F4F5F0] p-1">
              {TABS.map((t) => {
                const on = (t.id === "company") === company;
                return (
                  <Link key={t.id} to={t.to} className={`flex h-11 items-center justify-center gap-2 rounded-full text-sm font-semibold transition-colors ${on ? "bg-[#0F2D5E] text-white" : "text-[#495850] hover:text-[#0F2D5E]"}`} data-testid={`register-tab-${t.id}`}>
                    <t.icon className="h-4 w-4" /> {t.label}
                  </Link>
                );
              })}
            </div>
            <div className="mt-8">{company ? <RegisterCompanyForm onDone={setSentTo} /> : <RegisterPersonForm onDone={setSentTo} />}</div>
            <p className="mt-6 text-center text-sm text-[#495850]">
              Hai già un account? <Link to="/accedi" className="font-semibold text-[#0F2D5E] hover:underline" data-testid="go-login-link">Accedi</Link>
            </p>
          </>
        )}
      </div>
    </main>
  );
}
